import React from 'react';

const TYPE_COLORS    = { واجب: '#28E3DA',  مشروع: '#F1C267', اختبار: '#FA8686' };
const PRIORITY_COLORS = { منخفضة: '#5FCC9C', متوسطة: '#F1C267', عالية: '#FA8686' };
const STATUS_COLORS  = { 'لم يبدأ': 'rgba(255,255,255,0.35)', جاري: '#60A5FA', مكتمل: '#5FCC9C' };

const MONTHS_AR = ['يناير','فبراير','مارس','أبريل','مايو','يونيو',
                   'يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];

function formatDue(due) {
  if (!due) return null;
  try {
    const d = new Date(due.includes('T') ? due : `${due}T12:00:00`);
    return `${d.getDate()} ${MONTHS_AR[d.getMonth()]}`;
  } catch { return null; }
}

function daysUntil(due) {
  if (!due) return null;
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(due.includes('T') ? due : `${due}T12:00:00`);
  return Math.ceil((d - today) / 86400000);
}

function Badge({ text, color }) {
  return (
    <span
      className="inline-block px-2 py-0.5 rounded-full text-xs font-bold"
      style={{ background: `${color}18`, border: `1px solid ${color}40`, color }}
    >
      {text}
    </span>
  );
}

export default function TaskCard({ task, onCycleStatus, onEdit, onDelete }) {
  const typeColor   = TYPE_COLORS[task.type]   || '#28E3DA';
  const statusColor = STATUS_COLORS[task.status] || 'rgba(255,255,255,0.35)';
  const dueStr      = formatDue(task.due_date);
  const days        = daysUntil(task.due_date);
  const isOverdue   = days !== null && days < 0 && task.status !== 'مكتمل';
  const isUrgent    = days !== null && days >= 0 && days <= 3 && task.status !== 'مكتمل';
  const isDone      = task.status === 'مكتمل';

  return (
    <div
      className="rounded-xl p-4 transition-all group"
      style={{
        background: isDone
          ? 'rgba(255,255,255,0.02)'
          : 'linear-gradient(0deg, rgba(255,255,255,0.02), rgba(255,255,255,0.02)), rgba(8,20,35,0.6)',
        border: isDone
          ? '1px solid rgba(255,255,255,0.06)'
          : `1px solid ${typeColor}20`,
        opacity: isDone ? 0.65 : 1,
      }}
      dir="rtl"
    >
      <div className="flex items-start gap-3">
        {                          }
        <button
          onClick={() => onCycleStatus(task.id)}
          className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
          style={{
            borderColor: statusColor,
            background: isDone ? statusColor : 'transparent',
          }}
          title="تغيير الحالة"
        >
          {isDone && (
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
              <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </button>

        {             }
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <Badge text={task.type}     color={typeColor} />
            <Badge text={task.priority} color={PRIORITY_COLORS[task.priority] || '#F1C267'} />
            {task.week_num && (
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
                أسبوع {task.week_num}
              </span>
            )}
          </div>

          <p
            className="text-sm font-semibold leading-snug"
            style={{
              color: isDone ? 'rgba(255,255,255,0.4)' : '#fff',
              textDecoration: isDone ? 'line-through' : 'none',
            }}
          >
            {task.title}
          </p>

          {task.subject && (
            <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.4)' }}>
              {task.subject}
            </p>
          )}

          {task.description && (
            <p className="text-xs mt-1 leading-relaxed line-clamp-2" style={{ color: 'rgba(255,255,255,0.35)' }}>
              {task.description}
            </p>
          )}

          {            }
          <div className="flex items-center gap-3 mt-2 flex-wrap">
            {dueStr && (
              <span
                className="text-xs font-semibold"
                style={{
                  color: isOverdue ? '#FA8686' : isUrgent ? '#F1C267' : 'rgba(255,255,255,0.4)',
                }}
              >
                📅 {dueStr}
                {isOverdue && <span className="mr-1 text-xs">· متأخر!</span>}
                {isUrgent && !isOverdue && days === 0 && <span className="mr-1 text-xs">· اليوم!</span>}
                {isUrgent && !isOverdue && days === 1 && <span className="mr-1 text-xs">· غداً</span>}
              </span>
            )}
            {                              }
            <button
              onClick={() => onCycleStatus(task.id)}
              className="px-2 py-0.5 rounded-full text-xs font-bold transition-all"
              style={{
                background: `${statusColor}15`,
                border: `1px solid ${statusColor}35`,
                color: statusColor,
              }}
            >
              {task.status}
            </button>
          </div>
        </div>

        {             }
        <div className="flex-shrink-0 flex gap-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => onEdit(task)}
            className="w-7 h-7 rounded-lg flex items-center justify-center transition-colors"
            style={{ background: 'rgba(40,227,218,0.1)', color: '#28E3DA' }}
            title="تعديل"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M8.5 1.5L10.5 3.5L4 10H2V8L8.5 1.5Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
            </svg>
          </button>
          <button
            onClick={() => onDelete(task.id)}
            className="w-7 h-7 rounded-lg flex items-center justify-center transition-colors"
            style={{ background: 'rgba(250,134,134,0.1)', color: '#FA8686' }}
            title="حذف"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 3H10M4.5 3V2H7.5V3M5 5.5V9M7 5.5V9M3 3L3.5 10H8.5L9 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
